/**
 * Open "How Fomo-Fi works" from anywhere (doc 3 E9, E12; Paul 2026-10-28).
 *
 * `savedStep` is the step the user closed it at, published by WalkthroughHost: on the
 * account when signed in (`profile.walkthrough_last_step`, G2), in this browser when
 * signed out. It drives "Continue how it works (step N of 10)" (C9) and where the
 * walkthrough reopens (E10).
 */
import { useCallback } from "react";
import { openingStep } from "@/lib/walkthrough";
import { openWalkthroughSession, useWalkthroughSavedStep } from "@/lib/walkthroughStore";

export interface OpenWalkthroughOptions {
  /** The step that fits the page (splash and sign-up 1-3: 1; Analysis: 2; Plan: 3). */
  step?: number;
  /** The page it's opened over: "Connect bank", or "the home page" over the splash. */
  from: string;
  /** An "i" bubble or page link (E12): open at `step`, not at the saved step. */
  deepLink?: boolean;
}

export function useWalkthrough() {
  const savedStep = useWalkthroughSavedStep();

  const openWalkthrough = useCallback(
    (o: OpenWalkthroughOptions) =>
      openWalkthroughSession({
        step: openingStep({ pageStep: o.step ?? 1, savedStep, deepLink: o.deepLink }),
        from: o.from,
        startStep: o.step ?? 1,
      }),
    [savedStep],
  );

  return { openWalkthrough, savedStep };
}
